// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'bolt-solid';

export const Component = () => (
  <path d='M14.776 6.848 18.224 0h-8.86L4 12.74h7.327L6.921 24.52 21.624 6.848h-6.848Z' />
);

export const viewBox = '0 0 25 25';
